import dispatchToast from 'components/modules/Toast';

type CopyToClipboardOptions = {
  targetText: string;
  successMessage?: string;
  errorMessage?: string;
};

/**
 * テキストをクリップボードにコピーする
 *
 * @param options
 * @param options.targetText - コピーするテキスト
 * @param options.successMessage - コピー成功時のトーストメッセージ
 * @param options.errorMessage - コピー失敗時のトーストメッセージ
 */
export const copyToClipboard = async ({
  targetText,
  successMessage = 'コピーしました',
  errorMessage = 'コピーに失敗しました'
}: CopyToClipboardOptions): Promise<void> => {
  try {
    await navigator.clipboard.writeText(targetText);
    dispatchToast({
      id: 'toast-success-copy-to-clipboard',
      toastText: successMessage,
      center: true
    });
  } catch (error) {
    console.error('Failed to copy to clipboard:', error);
    dispatchToast({
      id: 'toast-failed-copy-to-clipboard',
      toastText: errorMessage,
      center: true
    });
  }
};
